export default __webpack_public_path__ + "static/media/wave-01.e8bd6366.png";